<template>
  <div id="ModalIndemnity">
    <transition name="fade">
      <div class="fixed inset-0 z-20" v-if="isIndemnityModalOpen">
        <div
          class="absolute inset-0 bg-black bg-opacity-75"
          @click="onIndemintyModalOpen"
        ></div>
        <div
          class="flex flex-col items-center justify-center w-screen h-screen"
        >
          <div class="relative animodal-inner">
            <div
              class="rounded-lg bg-white border w-[350px] xl:w-[500px] lg:w-[500px] p-6 border-stone-500 overflow-hidden"
            >
              <div class="flex justify-between">
                <div class="font-bold text-xl mb-4 text-[#09518C]">
                  Employer Portal Indemnity Clause
                </div>
                <font-awesome-icon
                  @click="onIndemintyModalOpen"
                  class="mt-1 cursor-pointer"
                  prefix="far"
                  icon="fa-times"
                />
              </div>
              <hr />
              <span class="text-gray-700">
                We fully understand and acknowledge that electronic
                communication is an insecure transmission media. We hereby
                indemnify ACCESS PFA Limited, and their respective
                directors, officers, employees, and agents from any and all
                liabilities, claims and expenses, including reasonable
                attorney’s fees, arising from data loss or in connection with
                the transmission of any content on this platform. We agree that
                for reset of password, a default password would be sent to the
                registered email of the employer’s contact person set as the
                default contact.
              </span>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    isIndemnityModalOpen: Boolean,
    onIndemintyModalOpen: Function,
  },
};
</script>

<style></style>
